import React from "react";

//Data
import { AffectedBreed, SectionData } from "./coverageData";

//Components
import SectionSubHeading from "./SectionSubHeading";
import TableRow from "./TableRow";

interface IllnessSubSectionProps {
    subSection: SectionData;
    getBreedSpecificBadge?: (affects: AffectedBreed[]) => React.ReactNode;
}

const IllnessSubSection: React.FC<IllnessSubSectionProps> = ({ subSection, getBreedSpecificBadge }) => {
    return (
        <div className="flex w-full flex-col gap-3">
            <SectionSubHeading
                icon={subSection.icon}
                title={subSection.title}
                badge={subSection.affects && getBreedSpecificBadge ? getBreedSpecificBadge(subSection.affects) : null}
            />
            <div>
                {subSection.includes.map(inclusion => {
                    return (
                        <TableRow
                            key={inclusion.title}
                            title={inclusion.title}
                            description={inclusion.description}
                            badge={inclusion.affects && getBreedSpecificBadge ? getBreedSpecificBadge(inclusion.affects) : null}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default IllnessSubSection;
